<app-general-header></app-general-header>

<header>Cancel Subscription</header>
<div class="container">
  <div class="unsubscribe-container">
    @if (!isUserUnsubscribed) {
      <p>
        You are about to cancel your subscription from the BrainKey Blog. We are sad to see you go.
        Are sure you want to unsubscribe?
      </p>
      <button class="button button-primary" (click)="cancelSubscription()">
        Unsubscribe
      </button>
      @if (error !== null) {
        <div @fadeIn class="subscription-error">{{ error }}</div>
      }
    } @else {
      <div @fadeIn>
        <p>
          We've received your request to unsubscribe from our emails.
          Want to stay in the loop (without the inbox deliveries)?<br>
          <span class="follow-text">Follow us on social!</span>
        </p>
        <div class="social-media d-flex">
          <div class="social-media-item">
            <a href="https://www.instagram.com/brainkeyai/" target="_blank">
              <img src="/assets/images/contact-us/instagram-icon.svg" alt="instagram">
            </a>
          </div>
          <div class="social-media-item">
            <a href="https://www.linkedin.com/company/brainkeyai/" target="_blank">
              <img src="/assets/images/contact-us/linkedin-icon.svg" alt="linkedin">
            </a>
          </div>
          <div class="social-media-item">
            <a href="https://www.facebook.com/BrainKeyAI" target="_blank">
              <img src="/assets/images/contact-us/facebook-icon.svg" alt="facebook">
            </a>
          </div>
          <div class="social-media-item">
            <a href="https://twitter.com/BrainkeyAI" target="_blank">
              <img src="/assets/images/contact-us/x-icon.svg" alt="x">
            </a>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<app-explore-your-brain></app-explore-your-brain>
<app-footer></app-footer>
